var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 32 32",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          stroke: "#010A11",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M20 24L12 16L20 8",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }